import { IEvent, IConsumer, createConsumer, createSubscriber } from '@cian/events-log';
import { createAppAsyncThunk } from '../utils/redux/createAppAsyncThunk';
import { setIsAuthenticated } from '../slices/authenticationSlice/authenticationSlice';
import { authByEventsLogEvent } from '../utils/auth';
import { TOPIC_USER } from '../constants/eventsLogTopics';

export interface IRequestAuthenticationParameters {
  onSuccess?(): void;
  onCloseNoAuth?(): void;
}

type TConsumerSingleton = (() => IConsumer) & { _instance?: IConsumer };

const getUserConsumer: TConsumerSingleton = (): IConsumer => {
  if (!getUserConsumer._instance) {
    getUserConsumer._instance = createConsumer({ topic: TOPIC_USER });
  }

  return getUserConsumer._instance;
};

export const requestAuthentication = createAppAsyncThunk(
  'authentication/requestAuthentication',
  (parameters: IRequestAuthenticationParameters, { dispatch, extra: { microfrontendsAPI } }) => {
    /* istanbul ignore else */
    if (typeof window !== 'undefined') {
      const consumer = getUserConsumer();

      const userSubscriber = createSubscriber(async (event: IEvent<unknown>) => {
        if (event.type === 'authenticated') {
          dispatch(setIsAuthenticated());

          /* istanbul ignore else */
          if (parameters && parameters.onSuccess) {
            parameters.onSuccess();
          }

          consumer.unsubscribe(userSubscriber);

          return;
        }

        if (event.type === 'authentication_modal_closed') {
          /* istanbul ignore else */
          if (parameters && parameters.onCloseNoAuth) {
            parameters.onCloseNoAuth();
          }

          consumer.unsubscribe(userSubscriber);
        }
      });

      consumer.subscribe(userSubscriber);

      const authParameters = { autoRefresh: false };

      if (microfrontendsAPI) {
        microfrontendsAPI.header.openAuthModal(authParameters);
      } else {
        authByEventsLogEvent(authParameters);
      }
    }
  },
);
